// Export all GraphQL fragments
export { 
  JOB_SUMMARY_FIELDS, 
  JOB_DETAIL_FIELDS, 
  JOBS_CONNECTION,
  JOBS_CONNECTION_DETAILED 
} from './jobs.js';
